export default function updateStationList(currentList, newList) {
  const newListAsObject = newList.reduce((stations, station) => {
    stations[station.jid] = station;
    return stations;
  }, {});

  function isStationInNewList(currentStation) {
    const isInNewList = newList.some(
      (newStation) => newStation.jid === currentStation.jid
    );
    return isInNewList;
  }

  function isStationInCurrentList(newStation) {
    const isInCurrentList = currentList.some(
      (currentStation) => currentStation.jid === newStation.jid
    );
    return isInCurrentList;
  }

  const updatedList = currentList
    .filter(isStationInNewList)
    .map((station) => newListAsObject[station.jid]);

  newList.forEach((newStation) => {
    if (!isStationInCurrentList(newStation)) {
      updatedList.push(newStation);
    }
  });
  return updatedList;
}
